<template>
    <SoliText
        @input="$emit('input', $event)"
        :value="value"
        :label="label"
        outlined
        :rules="emailRules"
        ref="email"
        @update:error="validate($event)"
        :hide-details="hideDetails"
        icon="alternate_email"
        @hook:mounted="$emit('mounted')"
        validateOnBlur
        :prevent="prevent"
        :errors="errors"
    ></SoliText>
</template>

<script>
export default {
    props: {
        value: {},
        prevent: {
            type: Boolean,
            default: false,
        },
        errors: {},
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        label: {
            type: String,
            default: "Your Email",
        },
    },
    data() {
        return {
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
        };
    },
    methods: {
        validate(valid) {
            this.$emit("valid", valid);
        },
    },
    watch: {
        value(val) {
            if (!val) return;
            let valid = val.includes("@") && val.includes(".");
            if (valid) this.$refs.email.$refs.input.validate();
            this.$emit("valid", !valid);
        },
    },
};
</script>

<style></style>
